import { render, staticRenderFns } from "./c_tarih_cell.vue?vue&type=template&id=6cb3b512"
import script from "./c_tarih_cell.vue?vue&type=script&lang=js"
export * from "./c_tarih_cell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports